export default "__VITE_ASSET__947f17f8__"